var _defs, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3, _path4, _path5, _path6, _rect0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #e3a761;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #331e11;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.5,
    y: 38.46,
    width: 4.34,
    height: 2.84
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.25,
    y: 34.23,
    width: 5.62,
    height: 11.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.55,35.79h2.65c1.94,0,3.51,1.57,3.51,3.51v1.35c0,1.99-1.62,3.61-3.61,3.61h-2.56v-8.47h0Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.25,
    y: 47.35,
    width: 2.5,
    height: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.33,
    y: 39.04,
    width: 2.5,
    height: 1.62
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.06,
    y: 37.85,
    width: 17.19,
    height: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.39,
    y: 38.1,
    width: 7.24,
    height: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 57.89,
    y: 38.46,
    width: 4.61,
    height: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.06,
    y: 32.82,
    width: 12.06,
    height: 4.21,
    transform: "translate(63.35 -28.79) rotate(65.42)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.8,
    y: 42.39,
    width: 14.1,
    height: 3.74,
    transform: "translate(116.77 14.27) rotate(115.1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.5,41.35v-3.5l-2-1-3-1-3-2-3-.5-1.5,1v2.5l.25,.5m12.25,4l-2,1.5-3,1-3,2h-3l-2-.5v-2.5l.75-.75m12.25-.75h4m-16.25,.75l.75-.75v-2.5l-.75-1.5m0,4.75h-6.25l-1.5-.75v-2.5l.5-.5m7.25-1h-6.25l-1,1m0,3h-4l-.5-1v-1l.5-1h4m23.5,3v3l2,.5v1.5m-2-5h5.5l1.5,1.5h5m-10,3.5l2,1v2.5l-1,1h-2l-1-1v-2.5l2-1Zm10-3.5l.5-1v-3.5m-.5,4.5l-2.5,5.5-.5,1.5,1,1.5,2-.5,1-1,3-6,.5-1.5v-6l-.5-1.5-2.5-4.69-1-.81-2-.5-1,1.31v1.19l3,5v2m0,0l-1-1.5h-4.5l-1.5,1h-5.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46,37.85v3.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.5,37.85h4v-2l-1.5-.5v-2m0,0l-2-.5v-2l.5-1.5h3l.5,1v2.5l-2,.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57,37.85h4l1.5,1v2l-1.5,1.5h-4.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62,38.35h3.5l1.5,.5,.5,1.5-.5,1-1.5,.5h-4"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 38,
    y: 30.04,
    width: 2.5,
    height: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.e4bb8174f99ab963a484bcb9b0d335dc.svg";
export { ForwardRef as ReactComponent };